import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["done", "partiallyDone", "orgNumber", "orgNumberFormContainer", "addressForm", "setupAddress", "setupPaymentOptions"];

  connect() {
    this.performedChecks = [];
    if(this.orgNumberTarget.value != '') {
      setTimeout(() => window.dispatchEvent(new Event('showaddresslist')), 100);
    }
  }

  initiateSetup(event) {
    this.orgNumberFormContainerTarget.classList.add('hidden');
    // Show "Saving settings"
    this.setupAddressTarget.classList.remove('hidden');
    this.setupAddress();
    // Show "Saving payment options"
    this.setupPaymentOptionsTarget.classList.remove('hidden');
    this.setupPaymentOptions(this.orgNumberTarget.value);
  }

  checkResults(result) {
    this.performedChecks.push(result);
    if (this.performedChecks.length == 2) {
      this.showResult();
    }
  }

  showResult() {
    if (this.performedChecks[0] && this.performedChecks[1]) { // If both checks returned true
      this.doneTarget.classList.remove('hidden');
    } else {
      this.partiallyDoneTarget.classList.remove('hidden');
    }
  }

  // This request is ALSO handled by SRJ, which provides the dom updates of status (see setup_address.js.erb)
  setupAddress() {
    Rails.ajax({
      type: 'PATCH',
      url: this.addressFormTarget.getAttribute('action'),
      data: new FormData(this.addressFormTarget),
      success: (response) => { this.checkResults(true) },
      error: (response, status, request) => { this.checkResults(false) }
    });
  }

  // This request is ALSO handled by SRJ, which provides the dom updates of status (see setup_payment_options.js.erb)
  setupPaymentOptions(orgNumber) {
    Rails.ajax({
      type: 'PATCH',
      url: `overview/setup_payment_options?org_number=${orgNumber}`,
      success: (response) => { this.checkResults(true) },
      error: (response, status, request) => { this.checkResults(false) }
    });
  }
}